import { useFeatureFlag } from './useFeatureFlags'

/**
 * Remote Config flag gating the English-language rollout.
 *
 * Uses the existing Cleverlohn `enable_*` flag style (matching `chatwoot_companies_enabled`),
 * not the `*_enabled` registry convention — that registry is scoped to the
 * canvas/client-canvas frontends, while this repo has its own RC system (see the
 * CL-1511 plan, "Flag naming exempt from the canvas RC convention").
 *
 * Defaults off in code (an unset flag resolves to `false` in staging/production
 * via the `FeatureFlags.getBoolean` fallback). Per-environment Console values:
 * staging `"true"`, production `"false"` until sign-off. Local dev resolves all
 * flags to `true`, and `?enable_english=true|false` overrides for testing.
 */
export const ENABLE_ENGLISH_FLAG = 'enable_english'

/** True when the English-language feature is enabled for the current environment. */
export function useI18nEnabled(): boolean {
  return useFeatureFlag(ENABLE_ENGLISH_FLAG)
}
